import merge from "lodash/merge"

import {
    RECEIVE_ERRORS,
    RECEIVE_CURRENT_USER,
    CLEAR_SESSION_ERRORS,
} from "../actions/session_actions"

const sessionErrorsReducer = (oldState = [], action) => {
    Object.freeze(oldState)
    switch (action.type) {
        case RECEIVE_ERRORS:
            return action.errors
        case RECEIVE_CURRENT_USER:
            return []
        case CLEAR_SESSION_ERRORS:
            return []
        default:
            return oldState
    }
}

export default sessionErrorsReducer
